<p-iconfield iconPosition="right">
  <input
    #searchInput
    pInputText
    type="text"
    [attr.data-cy]="dataCy()"
    [(ngModel)]="value"
    (change)="searchSubmit.emit()"
    placeholder="Search"
    class="form-control"
  />
  @if (value()) {
    <p-inputicon>
      <!-- mousedown keeps focus in the input, so no blur-triggered change
           searches the old query right before the clear does -->
      <button
        type="button"
        class="page-search__clear"
        data-cy="search-clear"
        aria-label="Clear search"
        (mousedown)="$event.preventDefault()"
        (click)="clear()"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </p-inputicon>
  }
</p-iconfield>
<button
  type="button"
  class="pi pi-search"
  [attr.data-cy]="searchButtonDataCy()"
  aria-label="Search"
  (click)="searchSubmit.emit()"
></button>
